import { Navigate, useLocation } from "react-router-dom";

const Auth = ({ children }) => {
  const location = useLocation();

  if (!localStorage.getItem("accessToken")) {
    return (
      <Navigate
        to="/entrance/signin"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  return children;
};

export default Auth;
